// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//import the vue instance
import Vue from 'vue'

//import the App component
import App from './App'

// import the vue router
import router from './router'

import axios from 'axios';


// import the vue store
import Vuex from 'vuex'
import 'es6-promise/auto'


// import clipboard copying features
import VueClipboard from 'vue-clipboard2'

import Mapbox from 'mapbox-gl-vue'
import Slick from 'vue-slick';

import VueLocalStorage from 'vue-localstorage'


Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(VueLocalStorage)


Vue.config.productionTip = false


// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})
const store = new Vuex.Store({
  state: {
    loggedIn: false,
    token: null,
  },
  mutations: {
    login (state, token) {
      state.loggedIn = true;
      state.token = token;
    },
    logout (state) {
      state.loggedIn = false;
      state.token = null;
    },

  }
})

export default store;

/* eslint-disable no-new */
new Vue({
  el: '#vue-app',
  router,
  store,
  localStorage: {
  },
  components: { App, Mapbox, Slick },
  template: '<App/>',
  
})




// WEBPACK FOOTER //
// ./src/main.js